import logger from 'utils/logger.util';

const L = logger('fixed');

const FRACTION_DIGITS = 2;

const fixed = (number) => {
  try {
    return number.toFixed(FRACTION_DIGITS);
  } catch (e) {
    return L.warn('()', e, 'returning same number:', number);
  }
};

// noinspection JSUnusedGlobalSymbols
export default fixed;
